import React from 'react';
import { ModalsKeys } from 'global';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { DashboardManagementCard, ExternalDashboardDialog } from 'modules/integrations/externalDashboards';

export const ExternalDashboardsManagement = () => {
  return (
    <PageContainer
      title="External Dashboards Management"
      modals={{
        [ModalsKeys.ExternalDashboardDialog]: <ExternalDashboardDialog />,
      }}
    >
      <DashboardManagementCard />
    </PageContainer>
  );
};
